<template>
  <AdminLayout><OrderStatusHistoryTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import OrderStatusHistoryTable from './OrderStatusHistoryTable.vue';

export default {
  name: 'OrderStatusHistory',
  components: { AdminLayout, OrderStatusHistoryTable },
};
</script>
